<template>
  <div class="mb-3">
    <label for="dataProvider-name" class="form-label">{{ $t('data_providers.form.name_label') }}</label>
    <input id="dataProvider-name" type="text" class="form-control" v-model="dataProvider.name"/>
  </div>
  <div class="mb-3">
    <label for="dataProvider-status" class="form-label">{{ $t('data_providers.form.status_label') }}</label>
    <select id="dataProvider-status" class="form-control" v-model="dataProvider.status" :aria-label="$t('data_providers.form.status_label')">
      <option value="ACTIVE">{{ $t('data_providers.status_values.active') }}</option>
      <option value="INACTIVE">{{ $t('data_providers.status_values.inactive') }}</option>
    </select>
  </div>
  <div class="mb-3">
    <label for="dataProvider-description" class="form-label">{{ $t('data_providers.form.description_label') }}</label>
    <textarea id="dataProvider-description" class="form-control" v-model="dataProvider.description" rows="3"></textarea>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import DataProvider from '../../../models/DataProvider';

const props = defineProps({
  modelValue: {
    type: DataProvider
  },
  isEdit: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue']);

const dataProvider = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value)
});
</script>